import styled from 'styled-components';

import { colors } from '../constants';

const Highlighter = styled.mark`
  display: inline-block;
  line-height: 0;
  padding-bottom: 0.625rem;
  color: ${colors.TEXT_PRIMARY};
  background-color: #ffecdb;
`;
Highlighter.displayName = 'Highlighter';

export default Highlighter;
